"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
//
// styles
//
const StyledContainer_1 = require("./StyledContainer");
const StyledFeatherIcon_1 = require("./StyledFeatherIcon");
const StyledImage_1 = require("./StyledImage");
const StyledLink_1 = require("./StyledLink");
const StyledDropdownLink_1 = require("./StyledDropdownLink");
const StyledListItem_1 = require("./StyledListItem");
//
// assets
//
const chart_webp_1 = __importDefault(require("../../../assets/images/dashboard/chart.webp"));
const withFlags_1 = require("../../../withFlags");
const RequiresFlag_1 = __importDefault(require("../../../RequiresFlag"));
const NavigationSidebar = () => {
    const location = (0, react_router_dom_1.useLocation)();
    const history = (0, react_router_dom_1.useHistory)();
    function handleToggleReports() {
        history.push('/reports/shipping');
    }
    function handlePressReports(e) {
        if (e.charCode === 13) {
            handleToggleReports();
        }
    }
    return (react_1.default.createElement(StyledContainer_1.StyledContainer, { className: 'navbar-nav' },
        react_1.default.createElement(StyledListItem_1.StyledListItem, { className: 'nav-item' },
            react_1.default.createElement(StyledLink_1.StyledLink, { className: 'nav-link orders-link', role: 'link', to: '/orders' },
                react_1.default.createElement(StyledFeatherIcon_1.StyledFeatherIcon, { className: 'fe fe-inbox' }),
                "Orders")),
        react_1.default.createElement(StyledListItem_1.StyledListItem, { className: 'nav-item' },
            react_1.default.createElement(StyledLink_1.StyledLink, { className: 'nav-link customers-link', role: 'link', to: '/customers' },
                react_1.default.createElement(StyledFeatherIcon_1.StyledFeatherIcon, { className: 'fe fe-shopping-cart' }),
                "Customers")),
        react_1.default.createElement(StyledListItem_1.StyledListItem, { className: 'nav-item' },
            react_1.default.createElement(StyledDropdownLink_1.StyledDropdownLink, { className: 'reports-dropdown', onClick: handleToggleReports, onKeyPress: handlePressReports, tabIndex: 0 },
                react_1.default.createElement(StyledImage_1.StyledImage, { src: chart_webp_1.default }),
                "Reports",
                location.pathname.includes('reports') ? (
                // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
                react_1.default.createElement(StyledFeatherIcon_1.StyledFeatherIcon, { className: 'fe fe-chevron-up', margin: '90px' })) : (
                // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
                react_1.default.createElement(StyledFeatherIcon_1.StyledFeatherIcon, { className: 'fe fe-chevron-down', margin: '90px' }))),
            location.pathname.includes('reports') ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", null,
                    react_1.default.createElement(StyledLink_1.StyledLink, { className: 'nav-link shipping-link', role: 'link', sublink: true, to: '/reports/shipping' }, "Shipping")),
                react_1.default.createElement(RequiresFlag_1.default, { flag: withFlags_1.Flags.metabaseReports },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(StyledLink_1.StyledLink, { className: 'nav-link metabase-link', role: 'link', sublink: true, to: '/reports/metabase' }, "Metabase"))))) : null),
        react_1.default.createElement(StyledListItem_1.StyledListItem, { className: 'nav-item' },
            react_1.default.createElement(RequiresFlag_1.default, { flag: withFlags_1.Flags.trackingPageManager },
                react_1.default.createElement(StyledLink_1.StyledLink, { className: 'nav-link tracking-page-link', role: 'link', to: '/tracking_page_editor' },
                    react_1.default.createElement(StyledFeatherIcon_1.StyledFeatherIcon, { className: 'fe fe-layout' }),
                    "Tracking Pages")),
            react_1.default.createElement(RequiresFlag_1.default, { flag: withFlags_1.Flags.installableApps },
                react_1.default.createElement(StyledLink_1.StyledLink, { className: 'nav-link apps-link', role: 'link', to: '/apps' },
                    react_1.default.createElement(StyledFeatherIcon_1.StyledFeatherIcon, { className: 'fe fe-grid' }),
                    "Apps"))),
        react_1.default.createElement(StyledListItem_1.StyledListItem, { className: 'nav-item' },
            react_1.default.createElement(StyledLink_1.StyledLink, { className: 'nav-link account-link', role: 'link', to: '/account' },
                react_1.default.createElement(StyledFeatherIcon_1.StyledFeatherIcon, { className: 'fe fe-user' }),
                "Account"))));
};
exports.default = NavigationSidebar;
